import { ItemOfferRequest } from '@dgx-pr-spa/shared/util';
import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { Offers } from '@dgx-pr-spa/shared/util';

export class ItemOfferHelper {
  constructor(
    private readonly offers: Offers,
    private readonly selectedOffer: ReplacementOffer
  ) {}

  get purchasePrice() {
    const currentItem = this.offers.current_item;
    const selectedOffer = this.selectedOffer;

    return selectedOffer?.rrp <= 0.01
      ? currentItem.purchase_price + selectedOffer.upgrade_fee
      : selectedOffer?.rrp;
  }

  get requestBody(): ItemOfferRequest {
    const offers = this.offers;
    const selectedOffer = this.selectedOffer;

    return {
      requestSource: 'BVUK', // TODO check static
      channelCode: '0035', // TODO check static
      channelGroupCode: '0005', // TODO check static
      clientCode: offers.current_plan?.client_code,
      clientGroupCode: offers.current_plan?.client_group_code,
      item: {
        itemCode: selectedOffer?.item_code,
        manufactorCode: selectedOffer?.manuf_code,
        model: selectedOffer?.model,
        serialNumber: '', // not used
        purchasePrice: this.purchasePrice,
        currency: 'GBP', // TODO check static
        warranty: selectedOffer?.warranty,
        is_item_owned: false, // TODO needs to be provided, set to false?
      },
      address: {
        addressLine1: offers.delivery_address?.address_line_1,
        addressLine2: offers.delivery_address?.address_line_2,
        addressLine3: offers.delivery_address?.address_line_3,
        addressLine4: offers.delivery_address?.address_line_4,
        postalCode: offers.delivery_address?.postal_code,
        countryCode: offers.delivery_address?.country_code,
      },
      personGid: offers.contact_details?.person_gid,
      otherIds: {
        otherId3: `${offers.current_plan?.company_code}${offers.current_plan?.scheme_code}${offers.current_plan?.reference_number}`,
        otherId3CategoryCode: 'WRPN',
      },
    };
  }
}
